import React from 'react';
import { Link } from 'react-router-dom';

const PrimaryButton = ({ children, to, onClick, icon: Icon, className = '' }) => {
  const buttonClass = `btn-primary ${className}`;

  if (to) {
    return (
      <Link to={to} className={buttonClass}>
        <span>{children}</span>
        {Icon && <Icon size={20} />}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={buttonClass}>
      <span>{children}</span>
      {Icon && <Icon size={20} />}
    </button>
  );
};

export default PrimaryButton;
